export default "__VITE_ASSET__CyObbWi0__"